import { RouterPathConfig } from './router-path.config';
import { VIEW_TYPE } from './view-type.enum';

export class PanelTypesConstants {
    public static ADMINS = {
        title: 'supervisors', //TODO:
        path: RouterPathConfig.DATA_MANAGEMENT_PATH.ADMINS,
        viewType: 'admins',
        status: 0,
        count: undefined,
        name: 'ADMINS',
        icon: 'admin1.svg'
    };

    public static EMPLOYEES = {
        title: 'empolyees', //TODO:
        path: RouterPathConfig.DATA_MANAGEMENT_PATH.EMPLOYEES,
        viewType: 'employees',
        status: 0,
        count: undefined,
        name: 'EMPLOYEES',
        icon: 'employee1.svg'
    };

    public static CLIENTS = {
        title: 'clients', //TODO:
        path: RouterPathConfig.DATA_MANAGEMENT_PATH.CLIENTS,
        viewType: VIEW_TYPE.CLIENTS,
        status: 0,
        count: undefined,
        name: 'CLIENTS',
        icon: 'organization1.svg'
    };

    public static SERVICES = {
        title: 'services', //TODO:
        path: RouterPathConfig.DATA_MANAGEMENT_PATH.SERVICES,
        viewType: 'services',
        status: 0,
        count: undefined,
        name: 'SERVICES',
        icon: 'services1.svg'
    };

    public static SYSTEMS = {
        title: 'systems', //TODO:
        path: RouterPathConfig.DATA_MANAGEMENT_PATH.SYSTEMS,
        viewType: 'systems',
        status: 0,
        count: undefined,
        name: 'SYSTEMS',
        icon: 'systems1.svg'
    };
    public static OPERATIONEMPLOYEE = {
        title: 'technicalOperatingStaff',
        path: RouterPathConfig.DATA_MANAGEMENT_PATH.OPERATIONEMPLOYEE,
        viewType: 'empolyeeOperation',
        status: 0,
        count: undefined,
        name: 'OPERATIONEMPLOYEE',
        icon: 'operationEmployees.svg'
    };
    public static TICKETING = {
        title: 'ticketingSystem'
    };
    public static TICKETING_MAIN_TYPES = {
        title: 'mainTypes',
        path: RouterPathConfig.MAINTECKETINGlIST,
        viewType: 'empolyeeOperation',
        status: 0,
        count: undefined,
        name: '1',
        icon: 'systems1.svg'
    };
    public static TICKETING_SUB_TYPES = {
        title: 'subTypes',
        path: RouterPathConfig.SUBTICKETINGLIST,
        viewType: 'empolyeeOperation',
        status: 0,
        count: undefined,
        name: '2',
        icon: 'systems1.svg'
    };
    public static NEW_CLIENT_MANAGEMENT = {
        title: 'clientManagement',
        path: RouterPathConfig.NEWCLIENTMANAGEMENT,
        viewType: 'empolyeeOperation',
        status: 0,
        count: undefined,
        name: '3',
        icon: 'organization1.svg'
    };
    public static GENERAL_SETTINGS = {
        title: 'generalSettings',
    };
    public static GENERAL_SETTINGS_EMPLOYEE = {
        title: 'employees',
        path: RouterPathConfig.GENERAL_SETTINGS_EMPLOYEE,
        viewType: 'empolyeeOperation',
        status: 0,
        count: undefined,
        name: '1',
        icon: 'systems1.svg'
    };
    
}
